export default "<rm-loader></rm-loader>\n<router-outlet></router-outlet>"